export default "__VITE_ASSET__Bcp8Iatm__ 720w";